import { type ReactNode } from 'react'
import { Flex } from '#app/components/layout/flex'
import { VisuallyHidden } from '#app/components/layout/visually-hidden'
import { cn } from '#app/utils/tailwind-merge.ts'

interface FormFieldProps {
	className?: string
	label?: ReactNode
	input?: ReactNode
	errors?: string[]
}

const FormField = ({ label, input, errors, className, ...props }: FormFieldProps) => {
	return (
		<Flex orientation="vertical" gap="2" className={cn('max-w-[320px] min-w-[50%] flex-1', className)} {...props}>
			<VisuallyHidden>{label}</VisuallyHidden>
			{input}
			<Flex orientation="vertical" gap="2" className="ml-4">
				{errors?.map((e: any) => (
					<p key={e} className="text-danger-text text-xs">
						{e}
					</p>
				))}
			</Flex>
		</Flex>
	)
}
FormField.displayName = 'FormField'

export { FormField }
